<template>
    <div>
        <r-button type="link" @click="showModal">Add Document</r-button>
        <v-form-wizard-modal v-if="isModalVisible" size="large" @close="closeModal" @submit="submit">
            <v-form-wizard-step step-name="Identity Proof" step-key="document-source" :is-self-managed="true">
                <select-source-form-step attribute-name="source" @input="setSource"/>
            </v-form-wizard-step>
            <v-form-wizard-step step-name="Identity Proof" step-key="camera-source" :disabled="isFileSource" next-step-label="Take a picture">
                <camera-form-step attribute-name="source"/>
            </v-form-wizard-step>
            <v-form-wizard-step step-name="Identity Proof" step-key="preview-image" next-step-label="Confirm">
                <preview-form-step attribute-name="blobDocumentImage"/>
            </v-form-wizard-step>
        </v-form-wizard-modal>
    </div>
</template>

<script>
    import vFormWizardModal from '@/components/form-wizard/v-form-wizard-modal';
    import vFormWizardStep from '@/components/form-wizard/v-form-wizard-step';
    import SelectSourceFormStep from './add-document-form-steps/select-source-form-step';
    import CameraFormStep from './add-document-form-steps/camera-form-step';
    import PreviewFormStep from './add-document-form-steps/preview-form-step';

    export default {
        name: 'add-document-modal',
        components: {
            vFormWizardStep,
            vFormWizardModal,
            SelectSourceFormStep,
            CameraFormStep,
            PreviewFormStep,
        },
        data() {
            return {
                isModalVisible: false,
                isFileSource: true,
            };
        },
        methods: {
            setSource({type}) {
                this.isFileSource = type === 'file';
            },
            showModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            },
            submit({blobDocumentImage}) {
                this.closeModal();
                this.$emit('submit', blobDocumentImage);
            },
        },
    };
</script>
